import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPanel.vue?vue&type=style&index=0&id=45b419ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b419ce"]])

export default __exports__